const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

function initBackToTop() {
  const button = $('.jw-back-to-top');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const pageWrapper = $('.page-wrapper');

    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight) {
      pageWrapper.scrollTo({ top: 0, left: 0, behavior });
    }

    const documentScroller = document.scrollingElement || document.documentElement;
    documentScroller.scrollTo({ top: 0, left: 0, behavior });
    window.scrollTo({ top: 0, left: 0, behavior });
  });
}

function initPerPage(root = document) {
  const wrappers = root.matches?.('.collection-wrapper') ? [root] : $$('.collection-wrapper', root);
  wrappers.forEach((wrapper) => {
    if (wrapper.dataset.jwPagingReady) return;
    const controls = $$('.jw-page-controls', wrapper);
    if (!controls.length) return;
    wrapper.dataset.jwPagingReady = 'true';
    const control = controls[0];
    const grid = $('.product-grid', wrapper);
    if (!grid) return;
    const selects = controls.map((item) => $('.jw-page-controls__select', item)).filter(Boolean);
    const paginations = controls.map((item) => $('.jw-pagination', item)).filter(Boolean);
    const total = Number(control.dataset.total || 0);
    const basePage = Number(control.dataset.basePage || 1);
    const serverPages = Number(control.dataset.serverPages || 1);
    const saved = Number(sessionStorage.getItem('jw-products-per-page'));
    const requested = Number(new URL(location.href).searchParams.get('per_page'));
    const allowed = [36, 72, 108, 360];
    const size = allowed.includes(requested) ? requested : (allowed.includes(saved) ? saved : 36);
    const pagesToLoad = size / 36;
    const currentPage = Math.floor((basePage - 1) / pagesToLoad) + 1;
    const totalPages = Math.max(1, Math.ceil(total / size));
    selects.forEach((select) => { select.value = String(size); });
    sessionStorage.setItem('jw-products-per-page', String(size));

    const pageUrl = (page) => {
      const url = new URL(location.href);
      url.searchParams.set('per_page', String(size));
      url.searchParams.set('page', String(((page - 1) * pagesToLoad) + 1));
      url.hash = 'ResultsList';
      return url;
    };

    const renderPagination = () => {
      const pages = [];
      for (let page = 1; page <= totalPages; page += 1) {
        if (page === 1 || page === totalPages || Math.abs(page - currentPage) <= 2) pages.push(page);
      }
      let previous = 0;
      const parts = pages.map((page) => {
        const gap = previous && page - previous > 1 ? '<span class="jw-pagination__ellipsis">…</span>' : '';
        previous = page;
        return `${gap}<a class="jw-pagination__page${page === currentPage ? ' is-current' : ''}" href="${pageUrl(page)}"${page === currentPage ? ' aria-current="page"' : ''}>${page}</a>`;
      }).join('');
      const markup = `<a class="jw-pagination__arrow${currentPage <= 1 ? ' is-disabled' : ''}" ${currentPage > 1 ? `href="${pageUrl(currentPage - 1)}"` : 'aria-disabled="true"'} aria-label="Previous page">‹</a><div class="jw-pagination__pages">${parts}</div><a class="jw-pagination__arrow${currentPage >= totalPages ? ' is-disabled' : ''}" ${currentPage < totalPages ? `href="${pageUrl(currentPage + 1)}"` : 'aria-disabled="true"'} aria-label="Next page">›</a>`;
      paginations.forEach((pagination) => { pagination.innerHTML = markup; });
    };

    const loadMore = async () => {
      const remaining = Math.min(pagesToLoad - 1, serverPages - basePage);
      if (remaining <= 0) return;
      controls.forEach((item) => item.classList.add('is-loading'));
      try {
        const urls = [];
        for (let step = 1; step <= remaining; step += 1) {
          const url = new URL(location.href);
          url.searchParams.set('page', String(basePage + step));
          urls.push(url);
        }
        const responses = await Promise.all(urls.map((url) => fetch(url, { credentials: 'same-origin' }).then((response) => response.text())));
        responses.forEach((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fetchedGrid = $('.product-grid', doc);
          if (!fetchedGrid) return;
          [...fetchedGrid.children].forEach((item) => grid.append(item));
        });
      } finally {
        controls.forEach((item) => item.classList.remove('is-loading'));
      }
    };

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const nextSize = Number(select.value);
        sessionStorage.setItem('jw-products-per-page', String(nextSize));
        const url = new URL(location.href);
        url.searchParams.set('per_page', String(nextSize));
        url.searchParams.delete('page');
        url.hash = 'ResultsList';
        location.assign(url);
      });
    });
    renderPagination();
    loadMore();
  });
}

function sortRecommendations(root = document) {
  $$('.jw-recommendations-grid', root).forEach((grid) => {
    if (grid.dataset.sorted) return;
    grid.dataset.sorted = 'true';
    [...grid.children]
      .sort((a, b) => Number(b.dataset.matchScore || 0) - Number(a.dataset.matchScore || 0))
      .forEach((item) => grid.append(item));
    const limit = Number(grid.dataset.displayLimit || 4);
    [...grid.children].forEach((item, index) => { item.hidden = index >= limit; });
  });
}

function init(root = document) {
  initBackToTop();
  initPerPage(root);
  sortRecommendations(root);
}

init();
new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) init(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });

